import React, { useContext, Fragment } from 'react'
import { Route, Switch, __RouterContext } from 'react-router-dom'
import style from '../components/app-help/help.style'
import { animated, useTransition } from 'react-spring'

// COMPONENTS
import Sidenav from '../components/app-help/Sidenav'
import Content from '../components/app-help/Content'
import DS5custreports from '../components/articles/DS5custreports'
import DSstandreports from '../components/articles/DSstandreports'
import DSCreatecustreports from '../components/articles/DSCreatecustreports'
import DSdataset from '../components/articles/DSdataset'
import DSView from '../components/articles/DSView'
import AuthorizeErrors from '../components/articles/AuthorizeErrors'
import UTM from '../components/articles/UTM'
import YandexDirectUTM from '../components/articles/YandexDirectUTM'
import ClientID from '../components/articles/ClientID'
import AmoCrmGa from '../components/articles/AmoCrmGa'
import Bitrix24 from '../components/articles/Bitrix24'
import RetailCrm from '../components/articles/RetailCrm'
import EnvyCrm from '../components/articles/EnvyCrm'
import Comagic from '../components/articles/Comagic'
import EcomEnable from '../components/articles/EcomEnable'
import RekomendaciiPoRazmetke from '../components/articles/rekomendacii-po-razmetke'
import RazmetkaUtmMetok from '../components/articles/razmetkaUtmMetok'
import NastrojkaUon from '../components/articles/nastrojka-uon'
import KastomnyCrm from '../components/articles/kastomnyCrm'
import Megaplan from '../components/articles/Megaplan'
import CallTracingBy from "../components/articles/CalltrackingBy";
import YclientsHelp from "../components/articles/YclientsHelp";

function useRouter() {
  return useContext(__RouterContext)
}

const Help = ({ classes }) => {
  const { location } = useRouter()

  const transitions = useTransition(location, location => location.key, {
    from: {
      opacity: 0,
      transform: 'rotateY(90deg)',
      position: 'absolute',
      width: '100%',
      transformOrigin: '50% 50%',
      willChange: 'transform',
    },
    enter: { opacity: 1, transform: 'rotateY(0)' },
    leave: { opacity: 0, transform: 'scale(0)' },
  })

  return (
    <Fragment>
      <div className={classes.help}>
        <Sidenav />

        <Content>
          {transitions.map(({ item, props: transition, key }) => (
            <animated.div key={key} style={transition}>
              <Switch location={item}>
                <Route path="/help" component={DSView} exact />
                <Route
                  path="/help/5-poleznyh-kastomnyh-otchetov-v-google-analytics"
                  component={DS5custreports}
                />
                <Route
                  path="/help/osnovnye-standartnye-otchety-ga"
                  component={DSstandreports}
                />
                <Route
                  path="/help/sozdanie-kastomnyh-otchetov-ga"
                  component={DSCreatecustreports}
                />
                <Route
                  path="/help/nabor-dannyh-dlya-podklyucheniya-ds"
                  component={DSdataset}
                />
                <Route
                  path="/help/kak-vklyuchit-elektronnuyu-torgovlyu-ga"
                  component={EcomEnable}
                />
                <Route
                  path="/help/authorize_errors"
                  component={AuthorizeErrors}
                />

                <Route path="/help/utm" component={UTM} />
                <Route
                  path="/help/yandex-direct-utm"
                  component={YandexDirectUTM}
                />
                <Route path="/help/poluchenie-clientid" component={ClientID} />
                <Route path="/help/podklyuchenie-amocrm" component={AmoCrmGa} />
                <Route path="/help/podklyuchenie-yclients" component={YclientsHelp} />
                <Route
                  path="/help/podklyuchenie-bitrix24"
                  component={Bitrix24}
                />
                <Route
                  path="/help/podklyuchenie-retail-crm"
                  component={RetailCrm}
                />
                <Route
                  path="/help/podklyuchenie-envy-crm"
                  component={EnvyCrm}
                />
                <Route path="/help/podklyuchenie-comagic" component={Comagic} />
                <Route path="/help/podklyuchenie-calltracking" component={CallTracingBy}/>
                <Route
                  path="/help/rekomendacii-po-razmetke-kampanij-google-ads"
                  component={RekomendaciiPoRazmetke}
                />
                <Route
                  path="/help/podklyuchenie-uon-travel-crm"
                  component={NastrojkaUon}
                />
                <Route
                  path="/help/razmetka-utm-metok"
                  component={RazmetkaUtmMetok}
                />
                <Route
                  path="/help/podklyuchenie-kastomnyh-crm"
                  component={KastomnyCrm}
                />
                <Route
                  path="/help/podklyuchenie-megaplan"
                  component={Megaplan}
                />
              </Switch>
            </animated.div>
          ))}
        </Content>
      </div>
    </Fragment>
  )
}

export default style(Help)
